<div class="w-100 mt-0 tool-container">
  <h4>Group Schema</h4>
  <mat-form-field class="me-3">
    <mat-label>Implementation</mat-label>
    <mat-select [(ngModel)]="groupSchema.solution">
      @for (app of applications; track app.value) {
        <mat-option [value]="app.value">
          {{ app.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="me-2">
    <mat-label>Group</mat-label>
    <input matInput [(ngModel)]="groupSchema.group" />
  </mat-form-field>
  <span class="radio-container ps-2 me-3">
    <mat-label>Response Type</mat-label>
    <mat-radio-group [(ngModel)]="groupSchema.response">
      <mat-radio-button [value]="true" class="me-3">CSV</mat-radio-button>
      <mat-radio-button [value]="false">JSON</mat-radio-button>
    </mat-radio-group>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="getGroupSchema()"
    [disabled]="!(groupSchema.solution && groupSchema.group)"
  >
    Request
  </button>
</div>
